<template>
    <div>
        <hr class="my-5">
        <h5>Patterns</h5>
        <div class="form-group row font-bold">
            <div class="col-sm-3">Field</div>
            <div class="col-sm-4">Find</div>
            <div class="col-sm-4">Replace</div>
            <div class="col-sm-1">
                <button type="button" @click="addPattern" class="btn btn-primary"><i class="fa fa-fw fa-plus"></i></button>
            </div>
        </div>
        <div class="form-group row" v-for="(pattern, index) in patterns" :key="index">
            <div class="col-sm-3">
                <input type="text" v-model="pattern.field" class="form-control" :name="`patterns[${index}][field]`">
            </div>
            <div class="col-sm-4">
                <input type="text" v-model="pattern.find" class="form-control" :name="`patterns[${index}][find]`">
            </div>
            <div class="col-sm-4">
                <input type="text" v-model="pattern.replace" class="form-control" :name="`patterns[${index}][replace]`">
            </div>
            <div class="col-sm-1">
                <button type="button" @click="deletePattern(index)" class="btn btn-danger"><i class="fa fa-fw fa-times"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initialPatterns: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            patterns: [],
        }
    },
    mounted() {
        this.patterns = this.initialPatterns ?? [];
        if (this.patterns.length === 0) {
            this.addPattern();
        }
    },
    methods: {
        addPattern() {
            this.patterns.push({});
        },
        deletePattern(index) {
            this.patterns.splice(index, 1);
        },
    }
}
</script>

<style scoped>

</style>
